var _circle, _circle2, _circle3, _circle4, _circle5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "in-play-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "in-play-icon__circle in-play-icon__circle--1",
    cx: 28,
    cy: 4,
    r: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "in-play-icon__circle in-play-icon__circle--2",
    cx: 22,
    cy: 4,
    r: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "in-play-icon__circle in-play-icon__circle--3",
    cx: 16,
    cy: 4,
    r: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "in-play-icon__circle in-play-icon__circle--4",
    cx: 10,
    cy: 4,
    r: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "in-play-icon__circle in-play-icon__circle--5",
    cx: 4,
    cy: 4,
    r: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPlay);
export default __webpack_public_path__ + "static/media/in-play.8014267c.svg";
export { ForwardRef as ReactComponent };